import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { getAllVerticals, addSpareParts } from '../../config/services/commercialService';
import { Button, Modal, FormControl, Form, Row, FormGroup, FormLabel } from 'react-bootstrap';
import Select from 'react-select';

const AddSparePartsModal = (props) => {
    const { showModal, hideModal, fetchSpareParts, pageNo} = props;
    const [model, setModel] = useState();
    const [spareName, setSpareName] = useState("");
    const [verticleList, setVericleList] = useState("");
    const [verticleID, setVerticleID] = useState("");
    const [setVerticle, setSetVerticle] = useState("");

    useEffect(() => {
        fetchVerticle();
    }, []);

    const fetchVerticle = () => {
        getAllVerticals()
            .then(res => {
                const response = res.data;
                if (response.statusCode == 1) {
                    const data = response.responseData.result;
                    let verticleData = []
                    data.map( (verticleDetails) => {
                        
                        let verticle= {
                          label:verticleDetails.verticalName,
                          value: verticleDetails._id
                        }
                        verticleData.push(verticle)
                    })
                    setVericleList(verticleData);
          
                  } else if (response.statusCode == 0) {
                    toast.error(response.error.errorMessage);
                  }
                })
                .catch((error) => {
                  console.log("error", error);
                });
          
    };

    const handleValidation = () => {
        if(model) {
            toast.error("Please select Model");
            return false;
        }

        return true;
    };

    const formSubmission = (event) => {
        event.preventDefault();
        const validationFlag = handleValidation();
        if(validationFlag) {
            const finalData = 
                {
                    verticalId: setVerticle,
                    sparePartName: spareName
                };

            const params = finalData;
            addSpareParts(params)
                .then(res => {
                    const response = res.data;

                    if (response.statusCode == 1) {
                        const data = response.responseData;
                        fetchSpareParts(pageNo);
                        toast.success(data.message);
                        hideModal();
                    } else if (response.statusCode == 0) {
                        toast.error(response.error.errorMessage)
                    }
                })
                .catch((error) => {
                    console.log('error', error);
                })
        }
    };

    return (
        <div className="main-wrapper">
            <Modal show={showModal} onHide={hideModal} centered size="xl" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Add Spare Parts</Modal.Title>
                </Modal.Header>

                <Modal.Body className="modal-body-height">
                    <Form onSubmit={(e) => formSubmission(e)}>
                        <div className='row' style={{marginTop: "30px"}}>
                            <FormGroup className='col-lg-6 col-xl-6'>
                                <FormLabel>Spare Part Name</FormLabel>
                                <FormControl
                                    value={spareName}
                                    name="spareName"
                                    onChange={(e) => {setSpareName(e.target.value)}}
                                    required
                                    type="text"
                                    placeholder="Spare Part Name"
                                />
                            </FormGroup>

                            <FormGroup className='col-lg-6 col-xl-6'>
                                <FormLabel>Product Type</FormLabel>
                                <Select
                                    onChange={(e) => {
                                        setVerticleID(e)
                                        setSetVerticle(e.value)
                                        
                                    } }
                                    options={verticleList}
                                    value={verticleID}
                                    placeholder="Product Type"
                                />
                            </FormGroup>
                        </div>

                        <Row className="justify-content-center" style={{marginTop: "30px"}}>
                            <Button variant="danger" onClick={hideModal}>Cancel</Button>
                            <Button className="ml-2" variant="success" type="submit">Submit</Button>
                        </Row>
                    </Form>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default AddSparePartsModal;